
import styled from "styled-components";

export const Pill = styled("span")<{ styles }>`
  cursor: default;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 12px;
  background-color: ${({ styles }) => styles?.background || '#f0f0f0'};
  color: ${({ styles }) => styles?.text || '#333'};
  line-height: 1.2;
  border-radius: 6px;
  padding: 6px 10px;
  white-space: nowrap;
  border: 1px solid ${({ styles }) => styles?.background || '#e0e0e0'};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  
  /* Ensure consistent spacing */
  margin: 2px 0;
  
  /* Handle hover state */
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  /* Ensure text is always readable */
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  
  /* Handle long text gracefully */
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;